










































































import { setList, changeSetStatus, setDetail } from "@/api/course";
import sortEditor from "./sortEditor.vue";
import { PageModule } from "@/store/module/page";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "storeSetList",
  components: {
    sortEditor,
  },
})
export default class extends Vue {
  searchInfo: any = {
    status: -1,
  };
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    const cache = PageModule.pageInfo.storeCourse;
    if (cache.pages) {
      this.page = cache.pages;
      this.getList({
        page: cache.pages,
        page_size: this.pageSize,
      });
    } else {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    }
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.name) {
      option.name = this.searchInfo.name;
    }
    if (this.searchInfo.status >= 0) {
      option.status = this.searchInfo.status;
    }
    setList(option).then((res: any) => {
      if (res.error_code === 0) {
        const arr = res.data.list || [];
        arr.map((item: any) => {
          item.status = item.status === 1;
        });
        this.tableData = arr;
        this.total = res.data.total;
        this.page = params.page;
      }
    });
  }
  handleAddSet() {
    this.$router.push({
      name: "storeSetDetail",
      query: {
        id: "0",
      },
    });
  }
  handleSearchSet() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  toDetail(row: any) {
    this.$router.push({
      name: "storeSetDetail",
      query: {
        id: row.combo_product_id,
      },
    });
  }
  confirmSetStatus(row: any) {
    if (row.status) {
      setDetail({ combo_product_id: row.combo_product_id }).then(
        (result: any) => {
          if (result.error_code === 0) {
            let str = "";
            result.data.item.map((i: any) => {
              if (i.item_type === 1) {
                str = str + i.product_name + "、";
              }
            });
            str = str.replace(/.$/, "");
            if (str) {
              const title = `开启购买 - ${row.name}`;
              const content = `开启套餐后，套餐下包含的已关闭课程都将开启。${str}`;
              this.$confirm(content, title, {
                confirmButtonText: "确定",
                confirmButtonClass: "mwow-button-filled success mini",
                cancelButtonText: "取消",
                cancelButtonClass: "mwow-button-filled mini",
                type: "warning",
              })
                .then(() => {
                  this.handleSetStatus(row.combo_product_id, 1);
                })
                .catch(() => {
                  this.getList({
                    page: this.page,
                    page_size: this.pageSize,
                  });
                });
            } else {
              this.handleSetStatus(row.combo_product_id, 1);
            }
          }
        }
      );
    } else {
      this.handleSetStatus(row.combo_product_id, 2);
    }
  }
  handleSetStatus(cid: number, status: number) {
    changeSetStatus({
      combo_product_id: cid,
      status: status,
    })
      .then((res: any) => {
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
        } else {
          this.$message({
            type: "error",
            message: "修改失败!" + res.message,
          });
        }
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      })
      .catch(() => {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
    PageModule.SET_PAGE_INFO({
      name: "storeCourse",
      key: "pages",
      value: e,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
